<template>
  <label :class="[sizeClasses]">
    <slot></slot>
    <span v-if="required">*</span>
    <span v-if="infoTooltip" class="has-tooltip">
      <img :src="`${scBaseUrl}/assets/images/info.svg`" alt="info" />
      <BaseToolTip
        :text="infoTooltip"
        class="tooltip-text"
        tip="bottom-right"
        :size="tooltipSize"
      ></BaseToolTip>
    </span>
  </label>
</template>

<script>
export default {
  props: {
    size: {
      default: "w-full",
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    tooltipSize: {
      type: String,
      default: "",
    },
  },
  computed: {
    sizeClasses() {
      return this.size;
    },
  },
};
</script>



// WEBPACK FOOTER //
// BaseLabel.vue?72ff15d4